import {FormControl, TextInput} from '@primer/react'

export interface RegexPatternInputProps {
  onChange: (value: string) => void
  value: string
  validationError?: string
  ref?: React.Ref<HTMLInputElement>
}

export function RegexPatternInput({ref: forwardedRef, onChange, value, validationError}: RegexPatternInputProps) {
  return (
    <FormControl required>
      <FormControl.Label>Pattern</FormControl.Label>
      <TextInput
        ref={forwardedRef}
        onChange={e => onChange(e.target.value)}
        aria-invalid={!!validationError}
        value={value}
        block
      />
      {validationError && <FormControl.Validation variant="error">{validationError}</FormControl.Validation>}
    </FormControl>
  )
}

RegexPatternInput.displayName = 'RegexPatternInput'
